import styles from "./RentenFaqLink.module.css";
import { useI18n } from "../../i18n";
import { Link } from "../Link";

function buildAgpssUrl(url: string, newSegment: string) {
  const parsedUrl = new URL(url);

  // If URL contains "/calculator/", replace it with the agpss segment
  if (parsedUrl.pathname.includes("/calculator/")) {
    parsedUrl.pathname = parsedUrl.pathname.replace("/calculator/", `/${newSegment}/`);
  } else {
    // Otherwise, insert segment before last path segment (old mechanism)
    const segments = parsedUrl.pathname.split("/").filter(Boolean);
    segments.splice(segments.length - 1, 0, newSegment);
    parsedUrl.pathname = "/" + segments.join("/");
  }

  return parsedUrl.toString();
}

export const RentenFaqLink = (props: { calculatorEnv: "agpss" | "website" | "dealer" }) => {
  const { t } = useI18n();

  if (props.calculatorEnv === "agpss") {
    const link = new URL(buildAgpssUrl(location.href, t("calculationDetails.feesAndTaxes.FAQLink.agpss.segment")));
    link.hash = t("calculationDetails.feesAndTaxes.FAQLink.agpss.anchor");

    return (
      <Link id="link-rentenfaq" to={link.toString()} target="_blank" className={styles.RentenFaqLink}>
        {t("calculationDetails.feesAndTaxes.FAQLink.text")}
      </Link>
    );
  } else {
    return (
      <Link
        id="link-feesandtaxes-faq"
        to={t("calculationDetails.feesAndTaxes.FAQLink.website.url")}
        target="_blank"
        className={styles.RentenFaqLink}
      >
        {t("calculationDetails.feesAndTaxes.FAQLink.text")}
      </Link>
    );
  }
};
